import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";

const COLORS = ["#D4FF00", "#00FF66", "#FF2A5F", "#FF3B30", "#FFFFFF"];

export default function Analytics() {
  const [data, setData] = useState(null);

  useEffect(() => { (async () => setData(await api.analytics()))(); }, []);

  if (!data) return <div className="mono text-white/50">LOADING…</div>;

  const stageData = Object.entries(data.stages).map(([k, v]) => ({ name: k.toUpperCase(), value: v }));
  const leadData = Object.entries(data.lead_stages).map(([k, v]) => ({ name: k.toUpperCase(), value: v }));

  return (
    <div className="space-y-8" data-testid="analytics">
      <div>
        <div className="mono text-white/40">METRICS · OS</div>
        <h1 className="text-4xl font-extrabold mt-2">Analytics</h1>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {[
          ["REVENUE", `₹${data.revenue.toLocaleString('en-IN')}`],
          ["PAID", `₹${data.paid.toLocaleString('en-IN')}`],
          ["OUTSTANDING", `₹${data.outstanding.toLocaleString('en-IN')}`],
          ["COLLECTION %", `${data.revenue ? Math.round((data.paid/data.revenue)*100) : 0}%`],
        ].map(([k, v]) => (
          <div key={k} className="bg-[#0E0E0E] p-6">
            <div className="mono text-white/40">{k}</div>
            <div className="font-sans text-3xl font-extrabold mt-3">{v}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="border border-white/10 bg-[#0C0C0C] p-5">
          <div className="mono text-white/60 mb-4">PROJECTS BY STAGE</div>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={stageData}>
              <XAxis dataKey="name" stroke="#666" tick={{ fontFamily: 'JetBrains Mono', fontSize: 10 }} />
              <YAxis stroke="#666" tick={{ fontFamily: 'JetBrains Mono', fontSize: 10 }} />
              <Tooltip contentStyle={{ background: '#0C0C0C', border: '1px solid #ffffff20' }} />
              <Bar dataKey="value" fill="#D4FF00" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="border border-white/10 bg-[#0C0C0C] p-5">
          <div className="mono text-white/60 mb-4">LEAD FUNNEL</div>
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie data={leadData} dataKey="value" innerRadius={70} outerRadius={110} paddingAngle={2}>
                {leadData.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip contentStyle={{ background: '#0C0C0C', border: '1px solid #ffffff20' }} />
            </PieChart>
          </ResponsiveContainer>
          <div className="flex flex-wrap gap-3 mt-4 justify-center">
            {leadData.map((l, i) => (
              <div key={l.name} className="flex items-center gap-2 mono text-white/60">
                <span className="w-2 h-2" style={{ background: COLORS[i % COLORS.length] }} />
                {l.name} · {l.value}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
